import Axios from 'axios'

const BASE_URL = process.env.NODE_ENV === 'production' ?
    'https://saltiz-picker-server.pikme.tv/'
    : 'http://localhost:3030/'


var axios = Axios.create({
    withCredentials: true
})

export const httpService = {
    get(endpoint, data) {
        return ajax(endpoint, 'GET', data)
    },
    post(endpoint, data) {
        return ajax(endpoint, 'POST', data)
    },
    put(endpoint, data) {
        return ajax(endpoint, 'PUT', data)
    },
    delete(endpoint, data) {
        return ajax(endpoint, 'DELETE', data)
    },
    sendBeacon(endpoint, data) {
        const blob = new Blob([data], { type: 'application/json' })
        navigator.sendBeacon(`${BASE_URL}${endpoint}`, blob)
    }
}

async function ajax(endpoint, method = 'GET', data = null) {
    try {
        const res = await axios({
            url: `${BASE_URL}${endpoint}`,
            method,
            data,
            params: (method === 'GET') ? data : null,
        })
        return res.data
    }
    catch (err) {
        throw err
    }
}
